/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ProjectDurationUnitResource = {
    Days: 'DAYS',
    Weeks: 'WEEKS',
    Months: 'MONTHS'
} as const;
export type ProjectDurationUnitResource = typeof ProjectDurationUnitResource[keyof typeof ProjectDurationUnitResource];


export function instanceOfProjectDurationUnitResource(value: any): boolean {
    for (const key in ProjectDurationUnitResource) {
        if (Object.prototype.hasOwnProperty.call(ProjectDurationUnitResource, key)) {
            // @ts-ignore
            if (ProjectDurationUnitResource[key] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ProjectDurationUnitResourceFromJSON(json: any): ProjectDurationUnitResource {
    return ProjectDurationUnitResourceFromJSONTyped(json, false);
}

export function ProjectDurationUnitResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProjectDurationUnitResource {
    return json as ProjectDurationUnitResource;
}

export function ProjectDurationUnitResourceToJSON(value?: ProjectDurationUnitResource | null): any {
    return value as any;
}

